angular.module('autoremind.dashboard.directives')
    .directive('resellerPayingCustomers', ['$parse', 'dashboardService', '$interval', 'resellerService', '$window', '$rootScope', function ($parse, dashboardService, $interval, resellerService, $window, $rootScope) {
        return {
            restrict: 'EA',
            scope: true,
            templateUrl: 'app/dashboard/widgets/reseller-paying-customers/reseller-paying-customers.html',
            link: function (scope, elem, attr) {
                scope.params = $parse(attr.params)(scope);
                scope.viewModel = {
                    stats: {
                        payingCust: null
                    },
                    updateInterval: angular.isDefined(scope.params.settings) && angular.isDefined(scope.params.settings.updateInterval) ? scope.params.settings.updateInterval : false,
                    isBusy: false,
                    widgetSizeClass: 'big'
                };
                scope.getStats = function () {
                    if (scope.viewModel.isBusy) {
                        return;
                    }
                    scope.viewModel.isBusy = true;
                    resellerService.getStats()
                        .then(function (data) {
                        scope.viewModel.isBusy = false;
                        scope.viewModel.stats.payingCust = resellerService.viewModel.stats.payingCust;
                    }, function () {
                        scope.viewModel.isBusy = false;
                    });
                };
                scope.getStats();
                scope.stopHandler = null;
                /* We should not keep updating due to limited number of requests to the ZOHO API, so user must refresh
                 if (scope.viewModel.updateInterval) {
                 scope.stopHandler = $interval(function () {
                 scope.getStats();
                 }, Math.abs(scope.viewModel.updateInterval) )
                 }
                 */
                var onResizeAction = function () {
                    scope.defineWidgetClass($window.innerWidth);
                    scope.$digest();
                };
                scope.defineWidgetClass = function (windowWidth) {
                    if (windowWidth > 991) {
                        scope.viewModel.widgetSizeClass = 'big';
                    }
                    else {
                        scope.viewModel.widgetSizeClass = 'medium';
                    }
                };
                scope.defineWidgetClass($window.innerWidth);
                angular.element($window).on('resize', onResizeAction);
                scope.$on("$locationChangeStart", function (event, next, current) {
                    if (scope.stopHandler) {
                        $interval.cancel(scope.stopHandler);
                    }
                    angular.element($window).off('resize', onResizeAction);
                });
                $rootScope.$on('event:auth-logout', function () {
                    if (scope.stopHandler) {
                        $interval.cancel(scope.stopHandler);
                    }
                    angular.element($window).off('resize', onResizeAction);
                });
            }
        };
    }]);
//# sourceMappingURL=reseller-paying-customers.js.map